<template>
  <div class="animated fadeIn">
    <b-modal
      ref="modal-lost-card"
      scrollable
      centered
      button-size="sm"
    >
      <template #modal-title>
        <h5 class="text-bold">
          <i class="fas fa-user-minus"></i> MOTIVO DA PERDA
        </h5>
      </template>
      <div class="form-group row pt-3 pb-5">
        <div class="col-md-12">
          <label for="txtGroup"
            ><small
              class="text-danger"
              v-if="form.motivoId.required"
              >*</small
            >
            Motivo:</label
          >
          <div class="input-group">
            <span class="input-group-addon"
              ><i class="fas fa-user-slash"></i
            ></span>
            <b-form-select
              v-model="form.motivoId.value"
              :options="form.motivoId.options"
            >
              <template slot="first">
                <option :value="null">
                  {{ $lang.Common.PlaceholderSelect }}
                </option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button
            @click.prevent="onSetLost"
            type="button"
            class="btn rounded btn-third btn-sm"
            v-b-tooltip.hover
            :title="'Salvar'"
          >
            <i class="fas fa-check-circle"></i
            ><span class="d-md-down-none"> Salvar</span>
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { createNewFollowupWithCard } from '@/components/tools/FollowupTools'
import ReasonLossRepository from '@/shared/http/repositories/configurations/reason.js'
import BoardRepositoryV2 from '@/shared/http/repositories/crm/board_v2.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'
import CardLostForm from './cardlostmodal-form.js'

const CardLostModel = {
  boardColumnId: null,
  motivoId: null,
  origemLeadId: null,
  pessoaId: null,
  posicao: 0,
  situacao: 0,
  reativado: 0,
  dataCriacao: null,
  dataInicioSituacao: null,
  dataReativacao: null
}

export default {
  name: 'CardLostModal',
  mixins: [ActionsForm],
  data () {
    return {
      data: CardLostModel,
      form: CardLostForm,
      card: null
    }
  },
  computed: {
    leadName () {
      let result = ''
      if (this.card && this.card.pessoa && this.card.pessoa.nome) {
        result = this.card.pessoa.nome
      }
      return result
    }
  },
  mounted () {
    this.onGetAllReasonLoss()
  },
  methods: {
    showModal (data) {
      this.card = data
      this.onLoadCardSyncDb(data)
      this.$refs['modal-lost-card'].show()
    },
    hideModal () {
      this.$refs['modal-lost-card'].hide()
    },
    onLoad () {},
    onLoadCardSyncDb (card) {
      if (card) {
        this.data.id = card.id
        this.data.boardColumnId = card.boardColumn ? card.boardColumn.id : null
        this.data.motivoId = card.motivoPerda ? card.motivoPerda.id : null
        this.data.posicao = card.posicao
        this.data.situacao = card.situacao
        this.data.reativado = card.reativado
        this.data.dataCriacao = card.dataCriacao
        this.data.dataInicioSituacao = card.dataInicioSituacao
        this.data.dataReativacao = card.dataReativacao
        this.data.origemLeadId = card.origemLead ? card.origemLead.id : null
        this.data.pessoaId = card.pessoa ? card.pessoa.id : null
      }
    },
    onGetAllReasonLoss () {
      loading.push()
      ReasonLossRepository.GetAllSituacaoActive('PERDIDO')
        .then((response) => {
          this.form.motivoId.options = this.onResultDropdown(
            response,
            null,
            (f) => f.nome
          )
        })
        .catch(this.onException)
    },
    onSetLost () {
      if (this.form.motivoId.value === null) {
        toast.warning(
          'Para prosseguir selecione um motivo de perda.',
          'ATENÇÃO!'
        )
        return
      }
      if (this.data) {
        loading.push()
        const lostData = {
          id: this.data.id,
          situacao: 'PERDIDO',
          motivoId: this.form.motivoId.value,
          dataInicioSituacao: new Date().toISOString()
        }
        BoardRepositoryV2.Card_PatchSituacao(
          this.card.boardColumn.board.id,
          this.card.boardColumn.id,
          this.card.id,
          lostData
        )
          .then((response) => {
            loading.pop()
            if (response.status === 200) {
              // Verifica se há mensagem sobre problema no e-mail
              if (response.data && response.data.message) {
                toast.warning(response.data.message, 'ATENÇÃO!')
              } else {
                toast.success(this.$lang.Common.Alerts.Success)
              }
              let value = this.form.motivoId.value
              let option = this.form.motivoId.options.find(
                (x) => x.value === value
              )
              createNewFollowupWithCard(
                this.card.pessoa.document,
                'sys_oportunidade_perdida',
                `Definiu o card como perdido por motivo de ${option.text}`,
                this.ip,
                this.latitude,
                this.longitude,
                this.card.id
              )
            }
            this.hideModal()
            this.$emit('Reload')
          })
          .catch(this.onException)
      } else {
        toast.success('Não foi possível localizar o Lead!', 'EXCLUSÃO DO LEAD')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/crm/details/modal/lost/cardlostmodal.vue